<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Fabric Expense No: {{ formData.fabricExpenseNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.fabricExpenseStatus === 'Y'
              ? 'success'
              : formData.fabricExpenseStatus === 'S'
              ? 'warning'
              : formData.fabricExpenseStatus === 'D' ||
                formData.fabricExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_fabricExpenseStatus || '新增' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDatePicker"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_oaExpenseProcess') || 'OA申请方式'"
            prop="oaExpenseProcess"
          >
            <dict-select
              v-model="formData.oaExpenseProcess"
              url="/master/common/dict/biz"
              :body="oaExpenseProcessParams"
              filterable
              size="mini"
              clearable
              @change="changeOaExpenseProcess"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_expensePayer') || '费用付款方'"
            prop="expensePayerCode"
          >
            <dict-select
              v-model="formData.expensePayerCode"
              url="/master/common/dict/biz"
              :selectedLabel.sync="formData.expensePayerName"
              :body="expensePayerParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payeeScmCode') || '收款供应商'"
            prop="payeeScmCode"
          >
            <dict-select
              v-model="formData.payeeScmCode"
              url="/master/common/dict/scm"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
              @change="payeeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="formData.oaExpenseProcess === 'A'">
          <el-form-item
            :label="$l('form_label_fabricPaymentRequestType') || '请款类型'"
            prop="fabricPaymentRequestType"
          >
            <dict-select
              v-model="formData.fabricPaymentRequestType"
              url="/master/common/dict/biz"
              :body="fabricPaymentRequestTypeParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formData.oaExpenseProcess === 'A'">
          <el-form-item
            :label="$l('INDEX.form_label_payeeScmBankName') || '收款方开户银行'"
            prop="bankName"
          >
            <el-input v-model="formData.bankName" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePayScmBank"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="formData.oaExpenseProcess === 'B'">
          <el-form-item
            :label="$l('form_label_costCategory') || '费用大类'"
            prop="costCategory"
          >
            <dict-select
              v-model="formData.costCategory"
              url="/master/common/dict/biz"
              :body="costCategoryParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="3" v-if="formData.oaExpenseProcess === 'B'">
          <el-form-item
            :label="$l('form_label_substituteInvoice') || '代用发票'"
          >
            <el-select
              v-model="formData.substituteInvoice"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-if="formData.oaExpenseProcess === 'B'">
          <el-form-item
            :label="$l('form_label_forwardGeneralManager') || '转送总经理'"
          >
            <el-select
              v-model="formData.forwardGeneralManager"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-if="formData.oaExpenseProcess === 'B'">
          <el-form-item
            :label="$l('form_label_businessConsumption') || '业务消费'"
          >
            <el-select
              v-model="formData.businessConsumption"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-if="formData.oaExpenseProcess === 'B'">
          <el-form-item :label="$l('form_label_otherSet') || '420'">
            <el-select
              v-model="formData.otherSet"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="formData.oaExpenseProcess === 'A'">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountName') || '收款方账户名称'
            "
          >
            <el-input v-model="formData.bankAccountName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountNo') || '收款方银行账号'
            "
          >
            <el-input v-model="formData.bankAccountNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountType') ||
                '收款方银行账户性质'
            "
          >
            <el-input v-model="formData.v_bankAccountType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountKind') ||
                '收款方银行账号类别'
            "
          >
            <el-input v-model="formData.v_bankAccountKind" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
            <el-input v-model="v_currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '原币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              :body="currencyUnitParams"
              url="/master/common/dict/biz"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_paymentMethod') || '付款方式'"
            prop="paymentMethod"
          >
            <dict-select
              v-model="formData.paymentMethod"
              url="/master/common/dict/biz"
              :body="paymentMethodParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_remark') || '付款用途'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_description') || '付款说明（不打印）'"
          >
            <el-input
              v-model="formData.description"
              type="textarea"
              :rows="5"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_notes') || '备注'">
            <el-input
              v-model="formData.notes"
              type="textarea"
              :rows="5"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :fabricExpenseCode="fabricExpenseCode"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
          :depCode="salesPersonInfo.depCode"
          :orgDepFullName="salesPersonInfo.orgDepFullName"
          :payeeScmCode="formData.payeeScmCode"
          :fabricDisabled="(formData.detailSource || detailSource) === 'A'"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :fabricExpenseCode="fabricExpenseCode"
        />
      </el-row>
    </el-form>
    <ChooseBank
      :visible.sync="chooseScmBankVisible"
      :title="$l('dialog_title_choose_payeeScmBank') || '选择收款方银行信息'"
      @confirm="updateBanInfo"
      :selectApi="selectBankApi"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import ChooseBank from '../choose-bank'
import dayjs from 'dayjs'
export default {
  components: { ItemTable, DocTable, ChooseBank },
  mixins: [EditLoading],
  props: {
    fabricExpenseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    type: { type: String, default: '' },
  },
  data() {
    return {
      requestDatePicker: this.requestDateEnd(),
      chooseScmBankVisible: false,
      oaExpenseProcessParams: { dictType: 'oaExpenseProcess' },
      fabricPaymentRequestTypeParams: { dictType: 'fabricPaymentRequestType' },
      expensePayerParams: { dictType: 'expensePayer' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      costCategoryParams: { dictType: 'costCategory' },
      selectOptions: [
        {
          label: this.$l('INDEX.YES') || '是',
          value: '0',
        },
        {
          label: this.$l('INDEX.NO') || '否',
          value: '1',
        },
      ],
      formData: {
        oaExpenseProcess: 'A',
        fabricPaymentRequestType: '4',
        salesPersonCode: '',
        salesPersonName: '',
        payeeScmCode: '',
        currencyAmount: 0,
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        v_bankAccountType: '',
        bankAccountKind: '',
        v_bankAccountKind: '',
        remark: '',
        description: '',
        notes: '',
        costCategory: '',
        substituteInvoice: '1',
        forwardGeneralManager: '1',
        businessConsumption: '1',
        otherSet: '1',
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
      },
      rules: {
        oaExpenseProcess: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        costCategory: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        bankName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        fabricPaymentRequestType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
      },
      selectBankApi: () => [],
      salesPersonInfo: {},
    }
  },
  computed: {
    v_currencyAmount() {
      const { currencyAmount } = this.formData
      return !currencyAmount ? '0' : currencyAmount.toLocaleString()
    },
    detailSource() {
      return this.type === 'addByRequestNotes' ? 'A' : 'B'
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.fabricExpenseCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    // 查询业务人员详情，主要取部门信息作为费用明细的默认分摊部门
    'formData.salesPersonCode': {
      async handler(userCode) {
        if (!userCode) return

        const res = await this.$api.sysUserDetailApi({ userCode })
        if (!res) return
        this.salesPersonInfo = res.body || {}
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
      this.$refs.docTable.loadData()
    },
    getData() {
      if (!this.fabricExpenseCode) return
      this.$api
        .fabricExpenseDetailApi({
          fabricExpenseCode: this.fabricExpenseCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || listItem.length < 1) {
        this.$message.warning(
          this.$l('tips_please_add_expense_item') || '请添加费用填报明细'
        )
        return
      }
      const listDoc = this.$refs.docTable.getTableData()
      this.loadingOpen()
      this.$api
        .fabricExpenseSaveApi({
          ...this.formData,
          listItem,
          listDoc,
          detailSource: this.formData.detailSource || this.detailSource,
        })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.fabricExpenseCode) {
            this.closeCurPage()
          } else {
            this.reload()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    async payeeChange(code) {
      const listBank = await this.getScmData({ scmCode: code })
      const bankData = !listBank || listBank.length > 1 ? {} : listBank[0] || {}
      this.updateBanInfo(bankData)
    },
    async getScmData(form) {
      if (!form.scmCode) return []
      return await this.$api
        .masterScmInfoBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    openChoosePayScmBank() {
      const { payeeScmCode } = this.formData
      if (!payeeScmCode) {
        this.$message({
          message: '请先选择收款供应商',
          type: 'warning',
        })
        return
      }
      this.selectBankApi = (form) =>
        this.getScmData({ ...form, scmCode: this.formData.payeeScmCode })
      this.chooseScmBankVisible = true
    },
    updateBanInfo(e) {
      const {
        bankName = '',
        bankAccountName = '',
        bankAccountNo = '',
        bankAccountType = '',
        v_bankAccountType = '',
        bankAccountKind = '',
        v_bankAccountKind = '',
      } = e || {}
      this.formData.bankName = bankName
      this.formData.bankAccountName = bankAccountName
      this.formData.bankAccountNo = bankAccountNo
      this.formData.bankAccountType = bankAccountType
      this.formData.v_bankAccountType = v_bankAccountType
      this.formData.bankAccountKind = bankAccountKind
      this.formData.v_bankAccountKind = v_bankAccountKind
    },
    changeOaExpenseProcess() {
      this.formData.substituteInvoice = '1'
      this.formData.forwardGeneralManager = '1'
      this.formData.businessConsumption = '1'
      this.formData.otherSet = '1'
      this.formData.fabricPaymentRequestType = '4'
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
